import { CART_PRODUCTS_PATH } from 'modules/cart-products/constants'

/**
 * Gets the cartProduct's store path.
 * @param  {number} id
 * @returns {string}
 */
function getPathCartProductUtil (id) {
  return `${CART_PRODUCTS_PATH.DATA}.${id}`
}

export {
  getPathCartProductUtil
}
